import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../api";
import { useApp } from "../context/AppContext";
import { Seo } from "../components/Seo";
import { Button } from "../components/ui/button";

export default function Register() {
  const { login } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/register", form);
      login(data);
      navigate("/dashboard");
    } catch (err) { setError(formatApiError(err)); } finally { setLoading(false); }
  };

  const input = "w-full h-12 rounded-md border border-input bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring";

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="register-page">
      <Seo title="Create Account" description="Create your DocGalaxy account to request Gujarat property documents." />
      <div className="bg-white border border-border rounded-2xl p-8 shadow-sm">
        <h1 className="font-display font-bold text-2xl">Create your account</h1>
        <p className="text-sm text-muted-foreground mt-1">Free signup. Request documents in minutes.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="register-form">
          {[["name", "Full Name", "text"], ["email", "Email", "email"], ["phone", "Mobile (optional)", "tel"], ["password", "Password (min 6 chars)", "password"]].map(([k, label, type]) => (
            <div key={k}>
              <label className="text-xs font-semibold" htmlFor={`reg-${k}`}>{label}</label>
              <input id={`reg-${k}`} type={type} required={k !== "phone"} className={input} value={form[k]}
                onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`register-${k}`} />
            </div>
          ))}
          {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}
          <Button type="submit" className="w-full h-12 bg-secondary hover:bg-secondary/90" disabled={loading} data-testid="register-submit-btn">
            {loading ? "Creating..." : "Get Started"}
          </Button>
        </form>
        <p className="mt-4 text-sm text-center">Already have an account? <Link to="/login" className="text-primary font-semibold" data-testid="login-link">Login</Link></p>
      </div>
    </div>
  );
}
